import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';
import { getDashaPeriods } from '../api';

function Mahadasha() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [dashaData, setDashaData] = useState(null);
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  });
  const [endDate, setEndDate] = useState(() => {
    const future = new Date();
    future.setFullYear(future.getFullYear() + 10);
    return future.toISOString().split('T')[0];
  });
  const [error, setError] = useState(null);

  const fetchDasha = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const requestData = {
        name: user?.fullname || user?.full_name || 'Hemant Rathore',
        datetime: user?.birthdate && user?.birthtime ? `${user.birthdate}T${user.birthtime}` : '1987-05-04T19:43:00',
        latitude: 26.14,
        longitude: 91.79,
        timezone: 5.5,
        place: user?.birthplace || user?.birth_place || 'Dispur',
        religion: 'Hindu',
        start_date: startDate,
        end_date: endDate
      };

      console.log('📤 MAHADASHA REQUEST PAYLOAD:', requestData);
      const response = await getDashaPeriods(requestData);

      console.log('📥 MAHADASHA RAW RESPONSE:', response);
      console.log('📥 MAHADASHA RESPONSE DATA:', response.data);

      if (!response.data || response.data.status !== 'success') {
        const message = response.data?.message || 'Dasha API returned unsuccessful status';
        console.warn('⚠️ Dasha API unsuccessful:', message, response.data);
        setError(`Dasha API failed: ${message}`);
        setDashaData(null);
      } else {
        setDashaData(response.data);
      }
    } catch (error) {
      console.error('Error fetching dasha:', error);
      setError('Unable to load Mahadasha data. Please try again.');
      setDashaData(null);
    } finally {
      setIsLoading(false);
    }
  }, [endDate, startDate, user]);

  useEffect(() => {
    fetchDasha();
  }, [fetchDasha]);

  const chatWithBot = () => {
    const birthDetails = `${user?.fullname || user?.full_name}, born on ${user?.birthdate || user?.birth_date} at ${user?.birthtime || user?.birth_time} in ${user?.birthplace || user?.birth_place}`;

    navigate('/chat', {
      state: {
        initialMessage: `Generate my Mahadasha analysis based on my birth details: ${birthDetails}. Start date: ${startDate}, End date: ${endDate}. Please provide detailed dasha period analysis.`
      }
    });
  };

  return (
    <div className="call-container">
      {/* Header Section */}
      <div className="heading">
        <h3>Mahadasha Analysis</h3>
      </div>
      <p className="refer-subtitle">Discover your planetary periods and life cycles</p>

      {/* Date Selection */}
      <div className="consultation-types">
        <div className="">
          <h3>Select Date Range</h3>
        </div>
        <div className="birth-details">
          <div className="detail-item">
            <div className="detail-content">
              <span className="consult-price">Start Date</span>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="date-input"
              />
            </div>
          </div>
          <div className="detail-item">
            <div className="detail-content">
              <span className="consult-price">End Date</span>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="date-input"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="">

        {dashaData && (
          <>
            <div className="status-table-container" >
              <h3>Current Antardasha</h3>
              <table className="account-action-table">
                <thead>
                  <tr>
                    <th>Lord</th>
                    <th>Period</th>
                    <th>Progress</th>
                    <th>Percentage</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{dashaData.analysis?.current_antardasha?.lord || 'N/A'}</td>
                    <td>{dashaData.analysis?.current_antardasha?.period || 'N/A'}</td>
                    <td>{dashaData.analysis?.current_antardasha?.progress || 'N/A'}</td>
                    <td>{dashaData.analysis?.current_antardasha?.percentage ? `${dashaData.analysis.current_antardasha.percentage}%` : 'N/A'}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="status-table-container" style={{ marginBottom: '20px' }}>
              <h3>Current Mahadasha</h3>
              <table className="account-action-table">
                <thead>
                  <tr>
                    <th>Lord</th>
                    <th>Period</th>
                    <th>Progress</th>
                    <th>Percentage</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{dashaData.analysis?.current_mahadasha?.lord || 'N/A'}</td>
                    <td>{dashaData.analysis?.current_mahadasha?.period || 'N/A'}</td>
                    <td>{dashaData.analysis?.current_mahadasha?.progress || 'N/A'}</td>
                    <td>{dashaData.analysis?.current_mahadasha?.percentage ? `${dashaData.analysis.current_mahadasha.percentage}%` : 'N/A'}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="status-table-container" style={{ marginBottom: '20px' }}>
              <h3>Numerology</h3>
              <table className="account-action-table">
                <thead>
                  <tr>
                    <th>Basic Number</th>
                    <th>Destiny Number</th>
                    <th>Name Number</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{dashaData.analysis?.numerology?.basic_number || 'N/A'}</td>
                    <td>{dashaData.analysis?.numerology?.destiny_number || 'N/A'}</td>
                    <td>{dashaData.analysis?.numerology?.name_number || 'N/A'}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="status-table-container" style={{ marginBottom: '20px' }}>
              <h3>Dasha Periods</h3>
              <table className="account-action-table">
                <thead>
                  <tr>
                    <th>Planet</th>
                    <th>Level</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  {dashaData.dasha_periods?.map((period, index) => (
                    <tr key={index}>
                      <td>{period.planet}</td>
                      <td>{period.level}</td>
                      <td>{new Date(period.start_date).toLocaleDateString()}</td>
                      <td>{new Date(period.end_date).toLocaleDateString()}</td>
                      <td>{period.duration_days ? `${period.duration_days} days` : 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Mahadasha;